import React from 'react'
import PageLayout from './PageLayout'
const mapNavs = [
    {
        id:1,
        title:"Store Front",
        des:"177 Court Street Brooklyn, NY 11201",
        away:"17 miles away"
    },
    {
        id:2,
        title:"Store Front",
        des:"177 Court Street Brooklyn, NY 11201",
        away:"25 miles away"
    },
    {
        id:3,
        title:"Store Front",
        des:"177 Court Street Brooklyn, NY 11201",
        away:"30 miles away"
    },
    {
        id:4,
        title:"Store Front",
        des:"177 Court Street Brooklyn, NY 11201",
        away:"46 miles away"
    }
]

const Location = () => {


 
    const navItems = mapNavs.map(item=>{
        return(
            <li key={item.id}>
                <span className="count">{item.id}</span>
                <h3 className="title">{item.title}</h3>
                <p className="des">{item.des}</p>
                <span className="away">{item.away}</span>
            </li>
        )
    })
  return (
    <PageLayout>
        <div className="page-top-content">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 mx-auto">
                        <div className="text-content-wrap text-center">
                            <h2 className="title-md">Locations</h2>
                            <p>Lorem ipsum dolor sit amet consectetur. Cursus dignissim hendrerit id phasellus. Imperdiet pellentesque adipiscing sit tortor lacus euismod. Ornare aenean adipiscing donec mauris sed proin. Risus consequat tellus placerat imperdiet orci blandit.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <section className="pt-150 pb-150">
            <div className="container">
                <div className="row flex-lg-row-reverse"> 
                    <div className="col-lg-8"> 
                        <div className="map-wrapper">
                            <iframe 
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12362.460953799611!2d-104.8850367!3d39.2289034!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xeb52018b34a0ecb!2sATTN%20Solutions!5e0!3m2!1sen!2s!4v1673676056899!5m2!1sen!2s" 
                                allowFullScreen="" 
                                loading="lazy" 
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 pe-lg-5 mt-5 mt-lg-0">
                        <ul className="map-nav-wrapper">{navItems}</ul> 
                    </div> 
                </div>
            </div>
        </section>
    </PageLayout>
  )
}

export default Location